import { StrictMode } from 'react'
import { createRoot, hydrateRoot } from 'react-dom/client'
import { App } from '@/app/App'
import type { Route } from '@/app/routes'
import { ROUTE_KINDS, matchRoute } from '@/app/routes'
import { isLocale } from '@/i18n/locales'
import '@/styles/index.css'

const isRenderedKind = (value: string | undefined): value is Route['kind'] =>
  value === 'notFound' || (ROUTE_KINDS as readonly string[]).includes(value ?? '')

const renderedRoute = (container: HTMLElement): Route | null => {
  const kind = container.dataset.routeKind
  const locale = container.dataset.routeLocale

  if (locale === undefined || !isLocale(locale)) return null
  if (!isRenderedKind(kind)) return null

  return { kind, locale }
}

const container = document.getElementById('root')

if (container !== null) {
  const serverRoute = renderedRoute(container)
  const route = serverRoute ?? matchRoute(window.location.pathname)

  const tree = (
    <StrictMode>
      <App route={route} />
    </StrictMode>
  )

  if (container.hasChildNodes()) hydrateRoot(container, tree)
  else createRoot(container).render(tree)
}
